import { Spinner } from "react-bootstrap";
import styles from "./loader.module.css"

export default function Loader() {
  return (
    <>
      <div className={`${styles.main}`}>
        <div className={`${styles.loader} translate-middle`}>
          <div className='d-flex align-items-center'>
            <Spinner animation="border" className='me-2 text-white' />
            <span className="fs-5 text-white">Loading...</span>
          </div>
        </div>
      </div>
    </>

  )
}